import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import axiosInstance from "../../configs/axios/axios ";
import { AUTHORIZATION } from "../../configs/axios/constantsAPI";
import {
  setCookie,
  getCookie,
  eraseCookie,
} from "../../configs/cookie-helper/cookieHelper";

export const loginAction = createAsyncThunk(
  "authentication/login",
  async (sendData: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        AUTHORIZATION,
        JSON.stringify(sendData)
      );
      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export interface AuthenticationState {
  actionStatus: string;
  alert: { delay: boolean; error: boolean; message: string };
  token: string;
  username: string;
  rule: string;
}

const token = getCookie("token");
const username = getCookie("username");
const rule = getCookie("rule");

let initialState: AuthenticationState;

if (token === null || username === null || rule === null) {
  initialState = {
    actionStatus: "",
    alert: {
      delay: false,
      error: false,
      message: "",
    },
    token: "",
    username: "",
    rule: "",
  };
} else {
  initialState = {
    actionStatus: "success",
    alert: {
      delay: false,
      error: false,
      message: "welcome",
    },
    token: token,
    username: username,
    rule: rule,
  };
}

export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    logoutAction: (state) => {
      state.actionStatus = "";
      state.alert = {
        delay: false,
        error: false,
        message: "",
      };
      state.token = "";
      state.username = "";
      state.rule = "";
      eraseCookie("token");
      eraseCookie("username");
      eraseCookie("rule");
    },
    delayAction: (state, action: PayloadAction<boolean>) => {
      state.alert = { ...state.alert, delay: action.payload };
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(loginAction.pending, (state) => {
      state.actionStatus = "loading";
      state.alert = {
        delay: false,
        error: false,
        message: "",
      };
    });
    addCase(loginAction.fulfilled, (state, { payload }) => {
      state.alert = {
        delay: true,
        error: payload.content.error,
        message: payload.content.message ? payload.content.message : "",
      };
      if (payload?.content?.error) {
        state.actionStatus = "rejected";
      } else {
        state.actionStatus = "success";
        state.token = payload.content.token;
        state.username = payload.content.username;
        state.rule = payload.content.rule;
        setCookie("token", state.token, 1);
        setCookie("username", state.username, 1);
        setCookie("rule", state.rule, 1);
      }
    });
    addCase(loginAction.rejected, (state, { payload }: any) => {
      state.actionStatus = "rejected";
      state.alert = {
        delay: false,
        error: true,
        message: payload?.content?.message
          ? payload?.content?.message
          : "Unknown error happend",
      };
    });
  },
});

export const { logoutAction, delayAction } = authenticationSlice.actions;

export const authentication = (state: RootState) => state.authenticationState;

export default authenticationSlice.reducer;
